import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMissingDefault = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 31,
		height: 31,
		rx: 15.5,
		fill: "#EB4B4B",
		stroke: "#EB4B4B"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.16458 20.2486L15.1495 8.49234C15.4385 8.00588 16.0536 7.8542 16.5233 8.15357C16.6564 8.23842 16.7684 8.35446 16.8503 8.49234L23.8353 20.2486C24.1564 20.7891 23.9937 21.4969 23.4718 21.8295C23.297 21.941 23.0957 22 22.8904 22H9.10949C8.49674 22 8 21.4855 8 20.8508C8 20.6382 8.05698 20.4297 8.16458 20.2486ZM16 20C16.5523 20 17 19.5523 17 19C17 18.4477 16.5523 18 16 18C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20ZM16 12C15.4477 12 15 12.4477 15 13V16C15 16.5523 15.4477 17 16 17C16.5523 17 17 16.5523 17 16V13C17 12.4477 16.5523 12 16 12Z",
		fill: "white"
	})]
});
export default SvgMissingDefault;
